<template>
  <v-dialog v-model="showDialog" width="500" persistent>
    <v-card dark>
      <v-card-title class="text-h5">
        {{title}}
      </v-card-title>

      <div class=" tw-text-[#aaa] tw-text-left px-6 pb-3">
        {{body}}
      </div>

      <v-divider></v-divider>

      <v-card-actions v-if="showDialog.redirect">
        <v-spacer></v-spacer>
        <v-btn class="tw-h-full tw-rounded-md" color="#D3AE37" dark @click="gotoHome">
          <strong>Ok</strong>
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["show", "errors"],
  data: () => ({
    showDialog: false,
  }),
  computed: {
    title() {
      return this.errors && (this.errors.title || "No title");
    },
    body() {
      return this.errors && this.errors.body;
    },
  },
  mounted() {
    this.showDialog = this.show;
  },
  watch: {
    show() {
      this.showDialog = this.show;
    },
  },
  methods: {
    gotoHome() {
      this.showDialog = false;
      return (location.href =
        process.env.VUE_APP_SERVER_ENV == "prod" ? "/casino-games" : "/");
    },
  },
};
</script>